module.exports = __webpack_public_path__ + "img/undraw_Airport_re_oqk1.e54b418f.svg";